export default "__VITE_ASSET__BEqvtjZw__"